import '@minimal/global.css';

import React from 'react';
import {createRoot} from 'react-dom/client';

import {LocalizationProvider} from '@minimal/locales';
import {themeConfig, ThemeProvider} from '@minimal/theme';
import '@providers/sentry';
import '@providers/i18n';

import App from './App';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <LocalizationProvider>
      <ThemeProvider noSsr defaultMode={themeConfig.defaultMode}>
        <App />
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>,
);
